import store from "../store";
import { APIService } from "./api";
const apiService = new APIService();

export class APIServiceFeedbackDashboard {
  getPropertyFeedbackNPS(data) {
    var config = {
      url: "/property/" + data + "/feedback/dashboard/stats",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackNPSWeekly(data) {
    var config = {
      url: "/property/" + data + "/feedback/nps/week",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCategoryNPSWeekly(propertyID, categoryID) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/feedback/category/" +
        categoryID +
        "/sentiment/week",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCategoryAllNPSWeekly(propertyID) {
    var config = {
      url: "/property/" + propertyID + "/feedback/category/sentiment/week",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCategoryStats(propertyID, categoryID) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/feedback/category/" +
        categoryID +
        "/stats",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCategoryNgramStats(propertyID, categoryID, ngramID) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/feedback/category/" +
        categoryID +
        "/ngram/" +
        ngramID +
        "/stats",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackAction(data) {
    var config = {
      url: "/property/" + data + "/feedback/action",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackActionByCategory(propertyID, categoryID) {
    var config = {
      url:
        "/property/" + propertyID + "/feedback/action/category/" + categoryID,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCategoryNPS(propertyID) {
    var config = {
      url: "/property/" + propertyID + "/feedback/nps/category",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCategoryFrequencyGraph(propertyID) {
    var config = {
      url: "/property/" + propertyID + "/feedback/category/frequency",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCustomerJourney(propertyID) {
    var config = {
      url: "/property/" + propertyID + "/customerjourney",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCustomerJourneyCategoryStats(propertyID, categoryID) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/feedback/customerjourneycategory/" +
        categoryID +
        "/stats",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackByCategory(propertyID, categoryID, page) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/feedback/category/" +
        categoryID +
        "/page/" +
        page,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyFeedbackCategoryWordCloud(propertyID, categoryID, wordID, page) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/feedback/category/" +
        categoryID +
        "/word/" +
        wordID +
        "/page/" +
        page,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getSurveyProperty(token) {
    var config = {
      url: "/survey/property/" + token,
      method: "get",
      headers: { "content-type": "application/json" }
    };
    return apiService.api(config);
  }

  getPropertyWordCloudAllgram(propertyID) {
    var config = {
      url: "/property/" + propertyID + "/wordcloud/ngrams",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyCategoryWordCloudAllgram(propertyID, categoryID) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/category/" +
        categoryID +
        "/wordcloud/ngrams",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyWordCloudByCategoryForWordCloudGraphic(propertyID, categoryID) {
    var config = {
      url: "/property/" + propertyID + "/category/" + categoryID + "/wordcloud",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyWordCloudByCategoryByWordForWordCloudGraphic(
    propertyID,
    categoryID,
    wordID
  ) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/category/" +
        categoryID +
        "/word/" +
        wordID +
        "/wordcloud",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyWordCloudByCustomerCategoryForWordCloudGraphic(
    propertyID,
    categoryJourneyID
  ) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/categoryjourney/" +
        categoryJourneyID +
        "/wordcloud",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getPropertyCategoryWordCloudTrigram(propertyID, categoryID, nGrams) {
    var config = {
      url:
        "/property/" +
        propertyID +
        "/category/" +
        categoryID +
        "/wordcloud/ngrams/" +
        nGrams,
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }

  getFeedbackSummaryDashboardHome(propertyID) {
    "/api/property/<property_id>/feedbacksummary/dashboard"
    var config = {
      url:
        "/property/" +
        propertyID +
        "/feedbacksummary/dashboard",
      method: "get",
      headers: {
        "x-access-token": store.getters.token,
        "content-type": "application/json"
      }
    };
    return apiService.api(config);
  }
}
